import { render, staticRenderFns } from "./ProfileAuthoringSelector.vue?vue&type=template&id=35289e96&"
import script from "./ProfileAuthoringSelector.vue?vue&type=script&lang=js&"
export * from "./ProfileAuthoringSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports